// extracted by mini-css-extract-plugin
export var primitiveLabel = "_ud-0";